import { toast } from "sonner";
import { Facebook, Twitter, Share2, Link as LinkIcon } from "lucide-react";

export const ShareButtons = ({ title }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = `Découvrez « ${title} » sur La Fondation des Artistes Handicapées de France`;

  const links = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
  };

  const copy = () => {
    navigator.clipboard?.writeText(url)
      .then(() => toast.success("Lien copié !"))
      .catch(() => toast.error("Impossible de copier le lien"));
  };

  const native = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
      } catch (err) {
        /* partage annulé par l'utilisateur */
      }
    } else {
      copy();
    }
  };

  return (
    <div className="flex items-center gap-3 mt-8" data-testid="share-buttons">
      <span className="text-zinc-500 text-xs uppercase tracking-widest mr-1">Partager</span>
      <a href={links.facebook} target="_blank" rel="noopener noreferrer" aria-label="Partager sur Facebook" data-testid="share-facebook"
        className="h-9 w-9 flex items-center justify-center border border-white/15 text-zinc-300 hover:text-white hover:border-[#2563EB] transition-colors">
        <Facebook className="h-4 w-4" />
      </a>
      <a href={links.twitter} target="_blank" rel="noopener noreferrer" aria-label="Partager sur X" data-testid="share-twitter"
        className="h-9 w-9 flex items-center justify-center border border-white/15 text-zinc-300 hover:text-white hover:border-[#2563EB] transition-colors">
        <Twitter className="h-4 w-4" />
      </a>
      <button onClick={native} aria-label="Partager" data-testid="share-native"
        className="h-9 w-9 flex items-center justify-center border border-white/15 text-zinc-300 hover:text-white hover:border-[#2563EB] transition-colors">
        <Share2 className="h-4 w-4" />
      </button>
      <button onClick={copy} aria-label="Copier le lien" data-testid="share-copy"
        className="h-9 w-9 flex items-center justify-center border border-white/15 text-zinc-300 hover:text-white hover:border-[#2563EB] transition-colors">
        <LinkIcon className="h-4 w-4" />
      </button>
    </div>
  );
};
